import { lazy } from 'react';
import { AppInit } from '@hwm/ui-lib';
import { actionInterceptor } from '@core/store/middleware/actionsInterceptorMiddleware';
import { styleConstants } from '@styles/constants';
import store from './core/store/store';
import { environment } from './environment';
import './index.css';
import 'react-datepicker/dist/react-datepicker.css';
import theme from './styles/theme';
import { AppPaths } from '@core/routes/routesPaths';
import { SidebarKeys } from '@shared/components/Sidebar/Sidebar.utils';
import { Trans } from '@lingui/macro';
import { UserDetails } from '@shared/components/UserDetails';
import { I18nProvider } from '@lingui/react';
import { Provider } from 'react-redux';
import { i18n } from '@lingui/core';
import { createRoot } from 'react-dom/client';
import { userProfileReducer } from '@core/store/library-stores/user-profile';
import { Preferences } from '@shared/components/Preferences/Preferences';

const LazyLayout = lazy(() => import('@shared/components/Layout'));
const parametersToKeep = ['from', 'to'];

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <I18nProvider i18n={i18n as any} forceRenderOnLocaleChange={false}>
    <Provider store={store}>
      {AppInit({
        LazyLayout: LazyLayout,
        actionInterceptor: actionInterceptor as any,
        applicationPaths: AppPaths,
        styleConstants: styleConstants,
        theme: theme,
        additionalConfig: {
          authority: environment.authority,
          clientId: environment.clientId,
          scope: environment.scope,
          silentLoginTimeout: environment.silentLoginTimeout,
        },
        initialLayoutProps: {
          appName: ['Data', 'View'],
          customButtons: [<Preferences />, <UserDetails />],
          links: [
            {
              label: <Trans>Graph&nbsp;View</Trans>,
              path: AppPaths.dataView.path.base,
              parametersToKeep,
            },
            {
              label: <Trans>Site/Device&nbsp;Configuration</Trans>,
              path: AppPaths.siteInformation.path.base,
              parametersToKeep,
            },
            {
              label: <Trans>Alarms</Trans>,
              path: AppPaths.alarms.path.base,
              parametersToKeep,
            },
            {
              label: <Trans>History</Trans>,
              path: AppPaths.history.path.base,
              parametersToKeep,
            },
            {
              label: <Trans>Reporting</Trans>,
              path: AppPaths.reporting.path.base,
              parametersToKeep,
            },
          ],
          className: 'hide-logout',
          sidebar: { state: true, section: SidebarKeys.siteList },
          navLinkActiveAsBrandColor: true,
          sessionConfig: {
            sessionCookieDomain: environment.sessionCookieDomain,
            sessionCookieIsSecure: environment.sessionCookieSecure,
            sessionIdleTimeout: environment.sessionCookieIdleTimeout,
          },
        },
        redirectEmptyUrl: AppPaths.dataView.path.base,
        setOidcUser: (d) => store.dispatch(userProfileReducer.slice.actions.setOidcUser(d)),
      })}
    </Provider>
  </I18nProvider>
);
